export default "__VITE_ASSET__gYda_Dlt__"